import axios from "axios";
import { BASE_URL } from "../constants/link";

export const httpRequest = ({ method, data, path, url, params, headers }) => {
  const accessToken = localStorage.getItem("hisob_new_token");
  const restaurant =
    localStorage.getItem("restaurantId")
    //  ||
    // "38721fb8-1cab-4bf0-b5a4-8665a62db5d5";
  const refreshToken = localStorage.getItem("refresh_token");
  return axios({
    method,
    data,
    url: url ? url : `${BASE_URL}/${path}`,
    params,
    headers: {
      ...headers,
      restaurant,
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
